import * as React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import StartComponent from '../commons/start/Start.component';
import ProjectListContainer from '../projects/ProjectList.container';
import MetricsContainer from './partials/Metrics.container';
import Metrics from 'src/entities/Metrics';
import HomeBanner from 'src/entities/HomeBanner';
import TestimonialContainer from 'src/modules/testimonial/Testimonial.container';

interface Props {
  metrics?: Metrics;
  homeBanner: HomeBanner;
}

const HomeComponent: React.StatelessComponent<Props> = (props: Props) => (
  <section className="Home">
    <Link
      to={props.homeBanner.url}
      target="_blank"
    >
      <div
        className="container-fluid Home-image"
        style={{
          backgroundImage: 'url(' + props.homeBanner.image + ')'
        }}
      />
    </Link>
    <MetricsContainer/>
    <div className="gap-30"/>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h1 className="bold-title">
            Oportunidades de inversión abiertas
          </h1>
        </div>
      </div>
      <div className="gap-30"/>
      <ProjectListContainer
        status="open"
        limit={3}
        listKey="homeOpenProjects"
        isSimple={false}
      />
    </div>
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 text-center">
          <div className="gap-20"/>
          <Link to="/muestrario-de-operaciones">
            <button className="btn btn-primary btn-lg">
              Ver más
            </button>
          </Link>
          <div className="gap-50"/>
          <div className="text-line">
            <p className="text-center f-s-36 f-w-100">
              <span className="bk-w">
                {
                  props.metrics ?
                    (
                      Number(props.metrics.totalInvested).toLocaleString('es') +
                      ' € INVERTIDOS EN ' +
                      props.metrics.totalFunded +
                      ' COMPAÑÍAS'
                    ) :
                    ''
                }
              </span>
            </p>
            <hr/>
          </div>
          <div className="gap-50"/>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h3 className="bold-subtitle">
            La mejor manera de invertir en Startups
          </h3>
        </div>
      </div>
      <div className="gap-30"/>
      <div className="row">
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Acceso"
                  src="/img/acceso.svg"
                  style={{width: 50}}
                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Acceso a un amplio número de startups
                </p>
                <p>
                  Buscamos las mejores oportunidades de inversión desde startups Seed y Growth a compañías Pre-MAB;
                  a través de contactos directos, referencias de nuestros socios, inversores y emprendedores;
                  relaciones con las mejores aceleradoras y venture builders;
                  y con los principales inversores del ecosistema español.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Selección"
                  src="/img/selecci-n.svg"
                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Selección de las mejores oportunidades de inversión
                </p>
                <p>
                  Después de un filtro inicial, en cada operación analizamos detalladamente el producto, equipo,
                  mercado, competidores, tracción, y otros campos clave; antes de presentarla a un comité interno que
                  decidirá si se publica la operación. Sólo publicamos el 2% de las compañías que recibimos cada año.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Restructuración"
                  src="/img/estructuraci-n.svg"
                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Estructuración profesional de las operaciones
                </p>
                <p>
                  Antes de la inversión, encargamos a un tercero la elaboración de una Due Diligence financiera, legal,
                  fiscal y laboral de la compañía. Si no hay salvedades, los inversores firman nuestros contratos
                  estandarizados (Pacto de Socios y Contrato de Sindicación), que cumplen los estándares del capital
                  riesgo y facilitan la entrada de futuros inversores.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Proceso"
                  src="/img/proceso.svg"
                  style={{width: 50}}

                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Proceso de inversión simple y riguroso
                </p>
                <p>
                  Nuestro equipo trabaja conjuntamente con el emprendedor para asegurar que los inversores tienen toda
                  la documentación necesaria para tomar la decisión de inversión. Todas las operaciones contienen una
                  extensa presentación con el análisis de la empresa. El proceso de inversión es sencillo y es 100%
                  online.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Diversificación"
                  src="/img/diversificaci-n.svg"
                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Diversificación de tu cartera
                </p>
                <p>
                  Todas las operaciones están divididas en tickets de 3.000€ para que puedas crearte una cartera
                  diversificada de varias compañías de calidad, ajustada al nivel de tu patrimonio financiero. Y una
                  vez has hecho la inversión, puedes seguir participando en las rondas futuras de tus compañías
                  invertidas.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="featured-card">
            <div className="row">
              <div className="col-xs-3">
                <div className="gap-5"/>
                <img
                  alt="Seguimiento"
                  src="/img/seguimiento.svg"
                />
              </div>
              <div className="col-xs-9">
                <p className="featured c-black-text deco-title">
                  Seguimiento de las operaciones
                </p>
                <p>
                  Los inversores tienen un espacio en la plataforma para hacer el seguimiento de su cartera y recibir
                  informes trimestrales de la evolución de sus inversiones. En cada operación, uno de los inversores
                  tiene una posición en el Consejo de Administración, y nuestro equipo también acompaña las startups
                  en su crecimiento.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="gap-30"/>
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <h3 className="bold-subtitle">
            Co-inversiones con algunos de los principales VCs en España
          </h3>
          <div className="gap-20"/>
        </div>
      </div>
      <div className="gap-30"/>
      <div className="row flexbox-container">
        <div className="col-sm-4 text-center">
          <img
            alt="Inveready"
            src="/img/inverready.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-4 text-center">
          <img
            alt="Keyword"
            src="/img/keyword.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-4 text-center">
          <img
            alt="La Caixa"
            src="/img/caixa.png"
          />
          <div className="gap-20"/>
        </div>
      </div>
      <div className="gap-30"/>
      <div className="row flexbox-container">
        <div className="col-sm-4 text-center">
          <img
            alt="Bankinter"
            src="/img/bankinter.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-4 text-center">
          <img
            alt="Rousaud"
            src="/img/seaya.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-4 text-center">
          <img
            alt="Rousaud"
            src="/img/antai.svg"
          />
          <div className="gap-20"/>
        </div>

      </div>
    </div>
    <div className="gap-50"/>
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <h3 className="bold-subtitle">Nuestro portfolio</h3>
          <div className="gap-20"/>
          <ProjectListContainer
            status="closed"
            limit={4}
            listKey="homeClosedProjects"
            isSimple={true}
            carousel={true}
            numberOfItems={3}
          />
        </div>
        <div className="col-md-12 text-center">
          <div className="gap-20"/>
          <Link to="/muestrario-de-operaciones#portfolio">
            <button className="btn btn-secondary btn-lg">
              Ver el portfolio completo
            </button>
          </Link>
        </div>
      </div>
    </div>
    <div className="gap-50"/>
    <TestimonialContainer/>
    <div className="gap-50"/>

    <div className="gap-50"/>
    <StartComponent/>
    <div className="gap-50"/>
    <div className="container">
      <div className="row">
        <div className="col-sm-3 text-center">
          <img
            alt="Expansión"
            src="/img/expansion.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-3 text-center">
          <img
            alt="El confidencial"
            src="/img/confidencial.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-3 text-center">
          <img
            alt="El País"
            src="/img/pais.png"
          />
          <div className="gap-20"/>
        </div>
        <div className="col-sm-3 text-center">
          <img
            alt="La Vanguardia"
            src="/img/vanguardia.png"
          />
          <div className="gap-20"/>
        </div>
      </div>
    </div>
    <div className="gap-50"/>
  </section>
);

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/modules/home/Home.component.tsx